/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

const RoutesConstant = {
  HOME_ROUTE: '/',
  BUY_ROUTE: '/buy',
  BUY_SPECIFIC_ROUTE: '/buy/:lotto',
  SUBSCRIBE_ROUTE: '/subscribe',
  OTP_ROUTE: '/otp',
  MOBILE_NUMBER_ROUTE: '/mobile-number',
  SEARCH_AND_BUY_ROUTE: '/search',
  SEARCH_LOTTERY_DRAW: '/search-draw',
  SEARCH_RESULT: '/search-result',
  PURCHASED_MESSAGE: '/purchased-message',
  ADD_NIC: '/add-nic',
  NOT_FOUND_ROUTE: '*',
  LOTTO_BASE_LAYOUT_ROUTE: '/lotto-base',
  LOTTO_BASE_SAMPLE_PAGE_ROUTE: '/lotto-base/lotto-base-page'
}

const PurchaseType = {
  BUY: 'Buy',
  SUBSCRIBE: 'Subscribe',
  SEARCH: 'Search'
}

const RequestPath = {
  LOTTERY_ONGOING: '/v1/lottery/ongoing',
  LOTTERY_PACKAGE: '/v1/lottery/packages',
  USER_LOGIN: '/v1/client/login',
  VERIFY_OTP: '/v1/client/verify',
  TICKET_ALLOCATE: '/v1/client/ticket-allocate',
  SEARCH_TICKETS: `/v1/lottery/search?limit=${process.env.REACT_APP_SEARCH_TICKET_LIMIT}&offset=0`,
  ADD_MISSING_NIC: '/v1/client/add-nic'
}

const RequestMethod = {
  GET: 'GET',
  POST: 'POST'
}

const SalesType = {
  ON_DEMAND: 'ON_DEMAND',
  SEARCH_AND_BUY: 'SEARCH_AND_BUY',
  SUBSCRIPTION: 'SUBSCRIPTION'
}

const PaymentMethod = {
  MOBILE: 'MOBILE'
}

const RequestSource = {
  WEB: 'WEB',
  WEB_WIDGET: 'WEB_WIDGET'
}

export {
  RoutesConstant,
  PurchaseType,
  RequestPath,
  RequestMethod,
  SalesType,
  PaymentMethod,
  RequestSource
}
